import { useTranslation } from '@edreamsodigeo/frontend-core';
import { Body, Box } from '@edreamsodigeo/prisma-design-system';
import { ItineraryDetailsContainer } from '@/components/ItineraryDetails';
import React from 'react';

export const StyledNoFeeKey = () => {
  const { t } = useTranslation();
  return (
    <Box>
      <Body inline type="base" weight="normal">
        {t('pricefreeze.deposit.initiative.discounted')}
      </Body>
    </Box>
  );
};

export const ItineraryDetailsIRUM = () => (
  <Box px="base">
    <ItineraryDetailsContainer />
  </Box>
);
